import { render, staticRenderFns } from "./amountList.vue?vue&type=template&id=f6752ee8&scoped=true"
import script from "./amountList.vue?vue&type=script&lang=js"
export * from "./amountList.vue?vue&type=script&lang=js"
import style0 from "./amountList.vue?vue&type=style&index=0&id=f6752ee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6752ee8",
  null
  
)

export default component.exports